import { useTranslation } from "@repo/translation";
import { parseIsoDate } from "@repo/utils";
import { type Locale } from "date-fns";

import { localizeDate } from "./LocalizedDate";

interface Props {
  fromDate?: string | Date;
  toDate?: string | Date;
  dateFnsLocale?: Locale;
  timezone?: string;
}

export const LocalizedDateRange = ({ fromDate, toDate, timezone }: Props) => {
  const { dateFnsLocale } = useTranslation();
  return <>{localizeDateRange(fromDate, toDate, dateFnsLocale, timezone)}</>;
};

export const localizeDateRange = (
  fromDate?: string | Date,
  toDate?: string | Date,
  dateFnsLocale?: Locale,
  timezone?: string
) => {
  const left = parseIsoDate(fromDate);
  const right = parseIsoDate(toDate);

  if (left && right && fromDate && toDate) {
    return `${localizeDate(fromDate, dateFnsLocale, timezone)} - ${localizeDate(
      toDate,
      dateFnsLocale,
      timezone
    )}`;
  }
  return localizeDate(fromDate || toDate || "", dateFnsLocale);
};
